import React from 'react';
import { FaFacebookF, FaInstagram, FaTiktok, FaYoutube, FaPinterestP, FaLinkedinIn } from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6';

const SocialSidebar = () => {
  const socialLinks = [
    {
      name: 'Facebook',
      url: 'https://www.facebook.com/share/1KgrmiR8YG/',
      icon: FaFacebookF,
      hoverBg: 'hover:bg-[#1877F2]',
    },
    {
      name: 'Instagram',
      url: 'https://www.instagram.com/itineraryseek?igsh=dHo4dmtqYjBybmIz',
      icon: FaInstagram,
      hoverBg: 'hover:bg-gradient-to-br hover:from-[#F58529] hover:via-[#DD2A7B] hover:to-[#8134AF]',
    },
    {
      name: 'X (Twitter)',
      url: 'https://x.com/ItinerarySeek?s=09',
      icon: FaXTwitter,
      hoverBg: 'hover:bg-neutral-900',
    },
    {
      name: 'YouTube',
      url: 'https://youtube.com/@itineraryseek?si=u-ZAaQPAHNF08vYw',
      icon: FaYoutube,
      hoverBg: 'hover:bg-[#FF0000]',
    },
    {
      name: 'TikTok',
      url: 'https://www.tiktok.com/@itineraryseek.com',
      icon: FaTiktok,
      hoverBg: 'hover:bg-neutral-900',
    },
    {
      name: 'Pinterest',
      url: 'https://pin.it/ENVZ7poev',
      icon: FaPinterestP,
      hoverBg: 'hover:bg-[#E60023]',
    },
    {
      name: 'LinkedIn',
      url: 'https://www.linkedin.com/in/itineraryseek-com-6b17753b1?utm_source=share_via&utm_content=profile&utm_medium=member_android',
      icon: FaLinkedinIn,
      hoverBg: 'hover:bg-[#0A66C2]',
    },
  ];

  return (
    <div className="fixed right-0 top-1/2 -translate-y-1/2 z-40 hidden md:flex flex-col gap-1 pr-2">
      <div className="bg-neutral-700 backdrop-blur-sm rounded-l-xl shadow-lg border border-r-0 border-neutral-600 py-3 px-2">
        {socialLinks.map((social) => {
          const IconComponent = social.icon;
          return (
            <a
              key={social.name}
              href={social.url}
              target="_blank"
              rel="noopener noreferrer"
              className={`w-9 h-9 rounded-full bg-neutral-500/50 ${social.hoverBg} text-neutral-200 hover:text-white flex items-center justify-center transition-all duration-300 hover:scale-110 mb-2 last:mb-0`}
              title={social.name}
            >
              <IconComponent className="text-sm" />
            </a>
          );
        })}
      </div>
    </div>
  );
};

export default SocialSidebar;
